var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipDatePicker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.02344H11V2.02344H10V3.02344H6V2.02344H5V3.02344H3C2.44667 3.02344 2 3.4701 2 4.02344V14.0234C2 14.5768 2.44667 15.0234 3 15.0234H13C13.5533 15.0234 14 14.5768 14 14.0234V4.02344C14 3.4701 13.5533 3.02344 13 3.02344ZM13 14.0234H3V7.02344H13V14.0234ZM13 6.02344H3V4.02344H5V5.02344H6V4.02344H10V5.02344H11V4.02344H13V6.02344Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipDatePicker);
export default __webpack_public_path__ + "static/media/ic-chip-date-picker.928497aa8dda8deb3fba9802f08dd8b5.svg";
export { ForwardRef as ReactComponent };